import * as React from "react";
import { SVGProps } from "react";

const Presearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31" {...props}>
    <path fill="#fff" d="M2 1.88h27.5v27.5H2z" />
    <path
      fill="#2d8eff"
      d="M11.32 19.39h2.94a5.68 5.68 0 0 0 2.43-.55 6.08 6.08 0 0 0 1.89-1.45 6.71 6.71 0 0 0 1.2-2.11 6.94 6.94 0 0 0 .44-2.44 6.06 6.06 0 0 0-.47-2.36 7.31 7.31 0 0 0-1.27-2.07 6.33 6.33 0 0 0-1.93-1.49 5.22 5.22 0 0 0-2.44-.58H6.37v18.79h5Zm0-8.51h2.5a1.34 1.34 0 0 1 .91.44 2.2 2.2 0 0 1 .47 1.59 2.12 2.12 0 0 1-.43 1.53 1.12 1.12 0 0 1-.84.44h-2.61Z"
    />
    <path
      fill="#2d8eff"
      d="M0 1.81v27.88a1.81 1.81 0 0 0 1.81 1.81h27.88a1.81 1.81 0 0 0 1.81-1.81V1.81A1.81 1.81 0 0 0 29.69 0H1.81A1.81 1.81 0 0 0 0 1.81Zm26 26H5.48A1.81 1.81 0 0 1 3.67 26V5.48a1.81 1.81 0 0 1 1.81-1.81H26a1.81 1.81 0 0 1 1.81 1.81V26A1.81 1.81 0 0 1 26 27.79Z"
    />
    <path fill="#2d8eff" d="M13.53 21.6h11.59v3.56H13.53z" />
  </svg>
);

export default Presearch;
